<template>
  <layout :show-calculator="showCalculator">
    <h1 slot="title" class="title">{{ $t('how-repay.page-title') }}</h1>

    <div class="wrapper">
      <p>{{ $t('how-repay.credit-paragraph') }}</p>

      <ul>
        <li v-for="({title, text}, index) in repaymentList" :key="index">
          <a :href="text" target="_blank" rel="noreferrer noopener">{{ title }}</a>
        </li>
      </ul>

      <take-loan v-if="notAuthorized"/>
    </div>
  </layout>
</template>

<script>
import { mapGetters } from 'vuex';
import Layout from '~/components/layout/sidebar.vue';
import TakeLoan from '~/app/shared/ui/take-loan.vue';
import { Meta } from '~/mixins/meta';

export default {
  name: 'HowRepay',
  components: { Layout, TakeLoan },

  mixins: [Meta('how-repay')],

  computed: {
    ...mapGetters('flow', ['showCalculator', 'notAuthorized']),

    repaymentList() {
      return this.$t('how-repay.repayment-list');
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  font-weight: 600;
}
.wrapper {
  min-height: 500px;

  @include not-desktop {
    min-height: 100px;
  }
}
</style>
